module.exports = __webpack_public_path__ + "assets/img/cart-steel-with-support.920d13b6.png";